/**
 * Shared dashboard workspace destinations — DashboardSubnav + Navbar account menu.
 *
 * Account actions (Stripe billing portal, logout) stay Navbar-only; they are not
 * in-app pages and must not appear in the horizontal subnav.
 */

/** @typedef {{ id: string, to: string, labelKey: string, pathPrefix: string, alsoExact?: string[] }} DashboardNavDestination */

/** @type {DashboardNavDestination[]} */
const DASHBOARD_NAV_DESTINATIONS = [
    {
        id: 'projects',
        to: '/dashboard/projects',
        labelKey: 'dashboard.nav.my_projects',
        pathPrefix: '/dashboard/projects',
        alsoExact: ['/dashboard'],
    },
    {
        id: 'portfolio',
        to: '/dashboard/portfolio',
        labelKey: 'dashboard.nav.portfolio',
        pathPrefix: '/dashboard/portfolio',
    },
    {
        id: 'account',
        to: '/dashboard/account',
        labelKey: 'dashboard.nav.account_settings',
        pathPrefix: '/dashboard/account',
    },
    {
        id: 'patterns',
        to: '/dashboard/patterns',
        labelKey: 'dashboard.patterns.title',
        pathPrefix: '/dashboard/patterns',
    },
    {
        id: 'technologies',
        to: '/dashboard/technologies',
        labelKey: 'dashboard.technologies.title',
        pathPrefix: '/dashboard/technologies',
    },
    {
        id: 'desk',
        to: '/dashboard/desk',
        labelKey: 'dashboard.desk.title',
        pathPrefix: '/dashboard/desk',
    },
];

/** Enterprise-only sections — shown in DashboardSubnav when plan is Enterprise. */
/** @type {DashboardNavDestination[]} */
const DASHBOARD_ENTERPRISE_NAV_DESTINATIONS = [
    {
        id: 'preferences',
        to: '/dashboard/preferences',
        labelKey: 'agentic.prefs.nav_link',
        pathPrefix: '/dashboard/preferences',
    },
    {
        id: 'learning',
        to: '/dashboard/learning',
        labelKey: 'agentic.learning.nav_link',
        pathPrefix: '/dashboard/learning',
    },
    {
        id: 'knowledge',
        to: '/dashboard/knowledge',
        labelKey: 'agentic.kb.nav_link',
        pathPrefix: '/dashboard/knowledge',
    },
];

/**
 * @param {DashboardNavDestination} item
 * @param {string} pathname
 */
function isDashboardNavActive(item, pathname) {
    if (Array.isArray(item.alsoExact) && item.alsoExact.includes(pathname)) {
        return true;
    }
    return pathname.startsWith(item.pathPrefix);
}

module.exports = {
    DASHBOARD_NAV_DESTINATIONS,
    DASHBOARD_ENTERPRISE_NAV_DESTINATIONS,
    isDashboardNavActive,
};
